import PageHeader from '@/content/Info/About/PageHeader';
import PageTitleWrapper from '@/components/PageTitleWrapper';
import { Typography, Container, Box } from '@mui/material';

import BackButton from '@/components/BackButton';

function AboutContent() {
  return (
    <>
      <Container maxWidth="xl">
        <PageTitleWrapper>
          <PageHeader />
        </PageTitleWrapper>
        <Box p={2}>
          <Typography variant={'h3'}>
            What is Admin Tools? What do we do? What are we here for?
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            One way of approaching this discussion is by saying that the
            internet is not only changing the way consumers interact with each
            other but it’s also dramatically changing the lives of enterprises,
            in an environment where things are constantly changing and evolving
            at such a rapid pace, keeping up is of utmost importance.
          </Typography>
          <Typography sx={{ mt: 0.2 }} variant={'body1'}>
            If you take a step back and think about cloud and SaaS and all the
            innovations that are going on right now, you can easily understand
            that the internet is a new backbone for enterprises as well as for
            consumers, but nobody seems to quite understand how the internet
            fully works.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            There are a lot of outside dependencies that sit outside your
            organization, and there are also a lot of things that influence the
            user experience, often times making it hard for enterprises to have
            a point of view on the end-user experience. Keeping in mind that the
            biggest part of the traffic brought to a website is over the
            internet, you can understand that knowing such information can be
            crucial for the success of any business.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            Basically, those environments are difficult to understand and even
            more difficult to discover, and that is where Admin Tools shines. We
            are simplifying all the information for our customers, in such a way
            that they can make sense of all of it, with easy to read
            infographics and stats, and detailed maps we are giving them the
            opportunity to not only be able to survive in this connected world
            but as we like to say thrive and be successful in a fully connected
            world.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            The importance of the internet is only going to increase in the
            future, we are expecting over 25 billion connected devices, and more
            than 5 billion connected humans, and only one internet. This is the
            reason why all of this work is very important. You need to see,
            understand, and manage this complex environment and that is why we
            are here.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            We try to come up with visualizations that map the real world, and
            that emulate how people see the network, everything is architected
            in such a way that any user will exactly know what they are looking
            at and how they can manage that information, and as a plus for the
            experienced ones we will have raw date from where they can extract
            direct information as they please.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'body1'}>
            Our monitoring services are created for everyone, starting with the
            owner of one website and going to the datacenters full of tech and
            hardware that need constant monitoring. We will be here to ensure
            that everyone gets real-time information and alerts, 24/7.
          </Typography>
          <Typography sx={{ mt: 3 }} variant={'h4'}>
            Admin Tools the only global monitoring network with millions of
            points around the world.
          </Typography>
          <Typography sx={{ mt: 0.5 }} variant={'h4'}>
            We are here for you 24/7 because your customers never sleep.
          </Typography>
        </Box>
        <BackButton />
      </Container>
    </>
  );
}

export default AboutContent;
